import { useState } from 'react'
import { Dialog } from 'primereact/dialog'
import { useTranslation } from 'react-i18next'

// local imports
import icon from 'assets/icons/location.svg'
import calendarLoading from 'assets/icons/loading-calendar.png'
import RateService from 'service/RateService'
import { IFloor } from 'types/FavoritesType'
import { INotRatedReservations } from 'types/RateType'
import useGetRateItems from './use-get-rate-items'
import Loader from 'components/ui/Loader'
import StarRating from 'components/ui/Rating/Rating'
import { ListItem, RatingItem, SearchButton, TextButton } from './styled'
import DateUtil from 'utils/DateUtil'

interface RatingDialogProps {
  visible: boolean
  closeDialog: () => void
  selectedRes: INotRatedReservations
  getReservationList: (showLoading?: boolean) => void
}

interface RatingValue {
  rateItemId: number
  rate: number
}

export default function RatingDialog({ visible, closeDialog, selectedRes, getReservationList }: RatingDialogProps) {
  const { t } = useTranslation()
  const { items, loading } = useGetRateItems()
  const [ratings, setRatings] = useState<RatingValue[] | undefined>(undefined)

  const setRatingValue = (id: number, rating: number) => {
    setRatings((prev) => {
      const isAlreadyRated = prev?.find((pr) => pr.rateItemId === id)
      if (isAlreadyRated) {
        return prev?.map((pr) => {
          if (pr.rateItemId === isAlreadyRated.rateItemId) pr.rate = rating
          return pr
        })
      }
      if (!!prev && prev?.length > 0) {
        return [...prev, { rateItemId: id, rate: rating }]
      } else return [{ rateItemId: id, rate: rating }]
    })
  }

  const saveRating = () => {
    if (!ratings) return
    RateService.saveRate({ rates: ratings, planType: selectedRes?.planType, reservationId: selectedRes?.reservationId })
      .then((_res) => {
        getReservationList()
        closeDialog()
      })
      .catch((err) => console.log(err))
  }

  const getAddress = (floor: IFloor) => {
    const { districtName, cityName, countryName, name, locationFirmName } = floor || {}
    return `${name}, ${districtName}, ${cityName}, ${countryName} ${locationFirmName || ''}`
  }

  const renderFooter = (saveRatings: () => void) => {
    const isDisabled = ratings?.length === items?.length
    return (
      <div style={{ display: 'flex', justifyContent: 'space-between', columnGap: '16px', marginTop: '32px' }}>
        <TextButton
          style={{ minWidth: '255px', width: '100%' }}
          label={t('evaluation.point-later')}
          onClick={closeDialog}
          className="p-button-outlined"
        />

        <SearchButton
          disabled={!isDisabled}
          style={{ minWidth: '255px', width: '100%' }}
          label={t('evaluation.point')}
          onClick={saveRatings}
          className="w-full"
        />
      </div>
    )
  }

  return (
    <Dialog
      blockScroll
      keepInViewport
      closeOnEscape={false}
      focusOnShow={false}
      closable={true}
      draggable={false}
      resizable={false}
      visible={visible}
      header={t('evaluation.tab-evaluation')}
      style={{ width: '650px' }}
      footer={renderFooter(saveRating)}
      onHide={closeDialog}>
      <ListItem>
        <div className="mr-4">
          <img src={icon} className="location-img" alt="reservation-location" />
        </div>
        <div className="list-content">
          <div className="title">{selectedRes?.floor?.locationName}</div>
          <div className="desc">{getAddress(selectedRes?.floor)}</div>
        </div>
        <div>
          <span style={{ fontSize: '13px', fontWeight: 400 }}>
            {DateUtil.dateFormat(new Date(selectedRes?.reservationDate))}
          </span>
        </div>
      </ListItem>

      {/* TODO: buraya bakılacak... */}
      {/* <div>lorem ipsum hizmetini puanlayınız.</div> */}

      <div className="mt-3">
        {loading ? (
          <ListLoader />
        ) : (
          <>
            {items?.map((it, index) => (
              <RatingItem key={it.id}>
                <div className="rate-item-title">{it.name}</div>
                <div className="rate-item-btn">
                  <StarRating value={ratings?.[index]?.rate || 0} id={it.id} setValue={setRatingValue} />
                </div>
              </RatingItem>
            ))}
          </>
        )}
      </div>
    </Dialog>
  )
}

function ListLoader() {
  return (
    <div className="py-2 my-3">
      <Loader src={calendarLoading} />
    </div>
  )
}
